import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {PlatformInterceptor} from './platform-interceptor';
import {ActiveTeamInterceptor} from './active-team.interceptor';
import {ImpersonationInterceptor} from './impersonation.interceptor';

// Http interceptor providers in outside-in order
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: PlatformInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ActiveTeamInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ImpersonationInterceptor, multi: true },
];
